export const browserFetch = window.fetch;

export default function mockBackend(config) {
  window.fetch = function (url, opts = { method: "GET", headers: new Headers() }) {
    let response;

    for (let entry of config) {
      if (entry.match(url, opts)) {
        let returned =
          typeof entry.response === "function" ? entry.response(url, opts) : entry.response;
        response = toResponse(returned);
        break;
      }
    }

    if (!response) {
      return browserFetch(url, opts);
    }

    return new Promise((resolve) => setTimeout(() => resolve(response), 25));
  };
}

const toResponse = (response) => {
  return new Response(JSON.stringify(response.body), response.init);
};
